import React from 'react';

import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import styles from './Feature.module.scss';

const Feature = ({ title, description, icon }) => {
  return (
    <div className={`${styles.container} col-md-4`}>
      <table>
        <thead>
          <tr>
            <th>
              <div className={styles['icon-border']}>
                <FontAwesomeIcon icon={icon} className={styles.icon} />
              </div>
            </th>

            <th className={styles.title}>{title}</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td />
            <td className={styles.paragraph}>{description}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

Feature.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)])
    .isRequired,
};

export default Feature;
